/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

$(document).ready( function () {

    $('.fancy-select').selectpicker();
    var datepickerArgs = {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        locale: {
            "firstDayOfWeek": 1 // start week on Monday
        },
        onChange: function(selectedDates, dateStr, instance) {
            $(instance.element).trigger('dateChanged'); // bubble up to the DOM
        }
    }
    $('input.datepicker-field').flatpickr(datepickerArgs);

    $.fn.checkFields = function(noScroll) {
        var selectedPaymentTypeId = $(this).val();
        $.get('/payment-requests/' + selectedPaymentTypeId + '/get-fields', function(response) {
            $('.payment-request-form .hideable').hide();
            $.each(response, function(index, field) {
                $('[name="'+field+'"]').parents('.hideable').show();
            });
            $('.hidden-payment-form-container').fadeIn(300);
            if(!noScroll) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('.hidden-payment-form-container').offset().top - 20
                }, 300);
            }
        });
    }

    $('button[data-payment-type-id]').on('click', function(x) {
        x.preventDefault();
        $thisButton = $(this);
        $thisButton.removeClass('btn-secondary')
            .addClass('btn-success')
            .siblings('button')
            .removeClass('btn-success')
            .addClass('btn-secondary');
        $thisButton.prepend('<i class="fa fa-fw fa-check-circle mr-1"></i>');
        $thisButton.siblings('button').find('i').remove();
        $('#payment_type_id').val($thisButton.attr('data-payment-type-id'));
        $('#payment_type_id').checkFields(false);
    });

    if($('#payment_type_id').length) {
        $('#payment_type_id').on('change', function() {
            // payment-requests/{paymentType}/get-fields
            $(this).checkFields();
        });
        if($('#payment_type_id').val()) {
            $('#payment_type_id').checkFields(true);
        }
    }

    $('body').on('click', '.repeater-add.repeater-inbound', function(x) {
        x.preventDefault();
        var $thisButton = $(this);
        var type = $thisButton.attr('data-repeater-type');
        var $parent = $thisButton.parent();
        var $repeaterTypeRows = $('body').find('.repeater-row.'+type);

        var currentCount = 1;
        if( $repeaterTypeRows.length > 1 ) {
            $repeaterTypeRows.each(function($repeater) {
                var thisRowNumber = parseInt($(this).attr('data-repeater-row-id'));
                currentCount = (thisRowNumber > currentCount ? thisRowNumber : currentCount);
            });
        }
        console.log(currentCount);

        $.ajax({
            url: 'inbound-payments-repeater',
            type: 'POST',
            data: {
                '_token': $('meta[name="csrf-token"]').attr('content'),
                'repeater_type': type,
                'current_repeater_count': currentCount,
            }, success: function(response) {
                var $newRepeaterRow = $(response);
                $newRepeaterRow.find('input.datepicker-field').flatpickr(datepickerArgs);
                $newRepeaterRow.insertAfter($parent);
                currentCount++;
                if($(window).innerWidth() < 768) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $newRepeaterRow.offset().top - 50
                    }, 500);
                }
            }, error: function(error) {
                alert(error);
            }
        })
    }).on('click', '.repeater-remove', function(x) {
        x.preventDefault();
        var $thisButton = $(this);
        var $parent = $thisButton.parent();
        $parent.remove();
    }).on('change', '.money-input', function() {
        var $moneyInput = $(this);
        var currentValue = $moneyInput.val();
        $moneyInput.val(parseFloat(currentValue.replace(/[^\d.-]/g, '')).toFixed(2));
    });

    var signaturePad;
    if($('canvas.signature').length > 0) {
        var $signatureArea = $('canvas.signature')[0];
        signaturePad = new SignaturePad($signatureArea);
        $('.clear-signature').on('click', function(x) {
            x.preventDefault();
            signaturePad.clear();
        });
    }

    $('.permit-submission').on('submit', function(x) {
        var $form = $(this);
        if(signaturePad.isEmpty()) {
            alert('Please sign inside the box before submitting your application.');
            return false;
        }
        var $signatureInputField = $form.find('input[name="signature_data"]');
        var signatureData = signaturePad.toDataURL();
        $signatureInputField.val(signatureData);
        return true;
    });

    // Returns signature image as data URL (see https://mdn.io/todataurl for the list of possible parameters)
    // signaturePad.toDataURL(); // save image as PNG
    // signaturePad.toDataURL("image/jpeg"); // save image as JPEG
    // signaturePad.toDataURL("image/svg+xml"); // save image as SVG

    // Draws signature image from data URL.
    // NOTE: This method does not populate internal data structure that represents drawn signature. Thus, after using #fromDataURL, #toData won't work properly.
    // signaturePad.fromDataURL("data:image/png;base64,iVBORw0K...");

    // Returns signature image as an array of point groups
    // const data = signaturePad.toData();
    // // Draws signature image from an array of point groups
    // signaturePad.fromData(data);
    // // Clears the canvas
    // signaturePad.clear();
    // // Returns true if canvas is empty, otherwise returns false
    // signaturePad.isEmpty();
    // // Unbinds all event handlers
    // signaturePad.off();
    // // Rebinds all event handlers
    // signaturePad.on();

    $.fn.selectToggler = function() {
        var $thisSelect = $(this);
        var selected = ($thisSelect.val() == 1);
        var target = $thisSelect.attr('data-target');
        var $targetContainer = $('.select-hidden[data-toggler="'+target+'"]');
        if(selected) {
            if($targetContainer.is('.row')) {
                $targetContainer.css('display', 'flex');
            } else {
                $targetContainer.show();
            }
        } else {
            $targetContainer.hide();
            $targetContainer.find(':input').attr('required', false);
        }
    }

    $('.select-toggler').on('change', function(x) {
        x.preventDefault();
        $(this).selectToggler();
    });

    $('.select-toggler').each(function() {
        if($(this).val() == true) {
            $(this).trigger('change');
        }
    });

    $('.custom-file-input').on('change',function(){
        var fileName = $(this).val();
        $(this).next('.custom-file-label').html(fileName.split('\\').pop());
    });

});
